export default __webpack_public_path__ + "static/media/loader.73ff534f.png";